<template>
  <section class="ba-textarea">
    <label><span class="label">{{label}}</span>
    <textarea
      :style="styletextarea"
      :name="name"
      :rows="rows"
      :cols="cols"
      :maxlength="maxlength"
      :placeholder="placeholder"
      :value="computedValue"
      :disabled="disabled"
      @input="$emit('input', $event.target.value)"
      :required="required"></textarea>
    </label>
  </section>
 
</template>

<script>
export default {
  name: "ba-textarea",
  props: {
    label: String,
    placeholder: String,
    name: String,
    required: String,
    cols: {
      type: Number,
      default: 20
    },
    rows: {
      type: Number,
      default: 2
    },
    maxlength: [String, Number],
    value: {
      type: String,
      default: ""
    },
    disabled: Boolean,
    styletextarea:{
      type: String,
      default: ""
    },
  },
  computed: {
    computedValue() {
      return this.value;
    }
  },
  watch: {
    value(value) {
      this.inputValue = value;
    }
  }
};
</script>

<style scoped>
.ba-textarea { position: relative; }
.ba-textarea .label {
  color: var(--ba-textarea-label-color, rgb(92, 92, 92));
  font-weight: normal;
  font-size: 0.9rem;
  position: absolute;
  pointer-events: none;
  line-height: 1rem;
  top: var(--ba-textarea-label-position, -1rem);
  text-indent: 1px;
  will-change: transform;
  white-space: nowrap;
}
.ba-textarea textarea {
  background: var(--ba-textarea-bg-color, rgb(255, 255, 255));
  color: var(--ba-textarea-color, rgb(92, 92, 92));
  box-shadow : var(--ba-textarea-box-shadow, 0px 1px 1px rgba(0, 0, 0, 0.2));
  font-size: 1rem;
  font-family: inherit;
  border-radius: 3px;
  border: 1px solid transparent;
  outline: none;
  resize: none;
  padding: 0.4rem;
  min-height: var(--ba-textarea-height, 4rem);
  width: var(--ba-textarea-width, 100%);
}
/* Disabled */
.ba-textarea textarea:disabled {
  color: var(--ba-input-disabled-color, rgb(206, 206, 206));
  background-color: var(--ba-input-disabled-bg-color, rgb(255, 255, 255));
}
/* Focus */
.ba-textarea textarea:focus {
  outline: none;
  border: var(--ba-textarea-focus, 1px solid rgb(50, 115, 220));
  box-shadow: var(--ba-textarea-focus-box-shadow, 0 0 0 2px rgba(50, 115, 220, 0.25));
}
.error .ba-textarea textarea:focus {
  outline: none;
  border: var(--ba-textarea-focus-error, 1px solid rgb(255, 56, 96));
  box-shadow: var(--ba-textarea-focus-error-box-shadow, 0 0 0 2px rgba(255, 56, 96, 0.25));
}
</style>
